import React from 'react';
import { testimonials } from '../../mock';
import { Star, Quote } from 'lucide-react';

export default function Testimonials() {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 border border-emerald-100 text-xs font-semibold text-emerald-700 uppercase tracking-wider mb-4">Success Stories</div>
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl text-slate-900 font-bold">Real Results, Real People</h2>
          <p className="mt-4 text-slate-600">Thousands trust The Loan Alliance to compare and choose the right financial products.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={t.name} className="relative rounded-2xl bg-slate-50 border border-slate-200 p-7 hover:border-emerald-300 hover:shadow-md transition-all fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
              <Quote className="absolute top-4 right-4 w-8 h-8 text-emerald-100" />
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />)}
              </div>
              <p className="text-slate-700 leading-relaxed">“{t.quote}”</p>
              <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <div className="font-semibold text-slate-900">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.location} • Score: <span className="font-semibold text-emerald-700">{t.score}</span></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
